import { css } from '@emotion/react';

import { getTheme } from 'src/utils/getTheme';

const { theme, isHosTheme } = getTheme();

export const styles = {
    forgottenPasswordWrapper: css({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '30px',
        alignSelf: 'stretch',
        [theme.breakpoints.up('lg')]: {
            width: '642px',
            padding: '60px 40px 40px 40px',
            gap: '30px',
        },
        ...(isHosTheme && {
            borderRadius: theme.custom.borderRadius[23],
            borderColor: theme.palette.secondary.dark,
            backgroundColor: theme.palette.common.white,
        }),
    }),
    forgottenPasswordFormWrapper: css({
        width: '100%',
        paddingTop: '10px',
    }),
    forgottenPasswordSubtitle: css({
        marginBottom: '30px',
    }),
    forgottenPasswordButton: css({
        marginTop: '30px',
        width: isHosTheme ? '215px' : '100%',
        borderRadius: '100px',
        padding: '16px',
    }),
    forgottenPasswordCloseButton: css({
        position: 'absolute',
        top: '20px',
        right: '20px',
        [theme.breakpoints.up('lg')]: {
            top: '25px',
            right: '25px',
        },
    }),
    back: css({
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        color: isHosTheme ? theme.palette.text.primary : theme.palette.customBlue,
        cursor: 'pointer',
        textDecoration: isHosTheme ? 'underline' : 'none',
        ':hover': {
            textDecoration: 'underline',
        },
        [theme.breakpoints.down('lg')]: {
            textDecoration: 'underline',
            margin: '0 auto',
        },
    }),
    backArrowIcon: css({
        marginRight: '10px',
        '.arrow-color': {
            fill: isHosTheme ? theme.palette.text.primary : theme.palette.customBlue,
        },
    }),
    loginDialogErrorBox: css({
        display: 'flex',
        padding: '20px',
        alignItems: 'flex-end',
        gap: '10px',
        alignSelf: 'stretch',
        background: theme.palette.error.light,
        color: theme.palette.primary.main,
        marginBottom: '20px',
    }),
};
